
const MyStorage = {

    isLogin: () => {
        let user = localStorage.getItem('user')
        return user != null
    },

    setUser: (user) => {
        if (user == null) {
            localStorage.removeItem('user')
            return
        }
        localStorage.setItem('user', JSON.stringify(user))
    },

    getUser: () => {
        let user = localStorage.getItem('user')
        if (user == null) {
            return user
        }
        else {
            return JSON.parse(user)
        }
    },

    setFileUrls: (obj) => {
        if (obj == null) {
            localStorage.removeItem('file_urls')
            return
        }
        localStorage.setItem('file_urls', JSON.stringify(obj))
    },

    getFileUrls: () => {
        let obj = localStorage.getItem('file_urls')
        if (obj == null) {
            return { "LibraryImages": "https://www.f4ltrainer.com/pcm_mobile_app/public/media/library/images/", "LibraryVideos": "https://www.f4ltrainer.com/pcm_mobile_app/public/media/library/videos/", "Equipment": "https://www.f4ltrainer.com/pcm_mobile_app/public/media/equipment/", "Slide": "https://www.f4ltrainer.com/pcm_mobile_app/public/media/slides/", "SpecialProgram": "https://www.f4ltrainer.com/pcm_mobile_app/public/media/programs/", "User": "https://www.f4ltrainer.com/pcm_mobile_app/public/media/users/" }
        }
        else {
            return JSON.parse(obj)
        }
    },

    setAllUsers: (obj) => {
        if (obj == null) {
            localStorage.removeItem('all_users')
            return
        }
        localStorage.setItem('all_users', JSON.stringify(obj))
    },

    getAllUsers: () => {
        let obj = localStorage.getItem('all_users')
        if (obj == null) {
            return []
        }
        else {
            return JSON.parse(obj)
        }
    },
}

export default MyStorage
